// convex/lib/config/module_ids.ts
// Source of truth for module IDs - used to generate modulesTypes
// This file must NOT import anything that uses modulesTypes to avoid circular dependencies

/**
 * Lista de todos los IDs de modulos y tablas del sistema.
 * Esta es la fuente de verdad para generar modulesTypes.
 *
 * IMPORTANTE: Mantener sincronizado con los dominios en ./domains/
 * La validacion en runtime alertara si hay discrepancias.
 */
export const MODULES = [
  // === SYSTEM ===
  "control_panel",
  "companies",
  "branches",
  "nomenclature",
  "waitlist",
  "deleted_records",

  // === SECURITY ===
  "users",
  "authAccounts",
  "roles",
  "permissions",
  "audit_logs",

  // === CLIENTS ===
  "clients",
  "recipients",

  // === REPORTS ===
  "reports",
  "report_executions",
  "report_shares",
  "pipeline_tracking",

  // === SUBSCRIPTIONS ===
  "subscription_plans",
  "company_subscriptions",

  // === NOTIFICATIONS ===
  "notifications",
  "user_invitations",

  // === UI (modules without tables) ===
  "dashboard",
  "settings",
  "profiles",

  // === DOCUMENTS ===
  "attachments",
  "tags",
  "entity_tags",

  // === LOGISTICS ===
  "logistics_orders",
  "packages",
  "shipments",
  "box_types",
  "carriers",
  "shipping_routes",
  "containers",
  "consolidation_calendars",
  "logistics_configurations",
  "logistics_payment_methods",
  "order_payments",
  "box_deliveries",
] as const;

export type ModuleId = (typeof MODULES)[number];

/**
 * Helper para verificar si un string es un modulo valido
 */
export function isValidModuleId(value: string): value is ModuleId {
  return (MODULES as readonly string[]).includes(value);
}
